import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "float-right" }
const _hoisted_3 = { class: "boxTitle mb-3" }
const _hoisted_4 = {
  width: "100",
  filter: "dataPagamento",
  sort: "dataPagamento",
  filterType: "date"
}
const _hoisted_5 = { width: "100" }
const _hoisted_6 = { width: "100" }
const _hoisted_7 = {
  width: "180",
  filter: "numeroRicevuta",
  sort: "numeroRicevuta"
}
const _hoisted_8 = {
  width: "180",
  filter: "nazione",
  sort: "nazione"
}
const _hoisted_9 = {
  filter: "note",
  sort: "note"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { colspan: "99" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "text-success" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_op_table = _resolveComponent("op-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.$store.state.isAdmin())
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary ml-2",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.aggiungiRicevuta && _ctx.aggiungiRicevuta(...args)))
          }, [
            _createVNode(_component_localized_text, {
              localizedKey: "Aggiungi ricevuta",
              text: "Aggiungi ricevuta"
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_localized_text, {
        localizedKey: "Estratto conto",
        text: "Estratto conto"
      })
    ]),
    _createVNode(_component_op_table, {
      class: "table table-striped",
      items: _ctx.ricevute
    }, {
      default: _withCtx((opData) => [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("td", _hoisted_4, [
              _createVNode(_component_localized_text, {
                localizedKey: "Data",
                text: "Data"
              })
            ]),
            _createElementVNode("td", _hoisted_5, [
              _createVNode(_component_localized_text, {
                localizedKey: "Dare",
                text: "Dare"
              })
            ]),
            _createElementVNode("td", _hoisted_6, [
              _createVNode(_component_localized_text, {
                localizedKey: "Avere",
                text: "Avere"
              })
            ]),
            _createElementVNode("td", _hoisted_7, [
              _createVNode(_component_localized_text, {
                localizedKey: "Numero",
                text: "Numero"
              })
            ]),
            _createElementVNode("td", _hoisted_8, [
              _createVNode(_component_localized_text, {
                localizedKey: "Nazione",
                text: "Nazione"
              })
            ]),
            _createElementVNode("td", _hoisted_9, [
              _createVNode(_component_localized_text, {
                localizedKey: "Note",
                text: "Note"
              })
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("tbody", null, [
          (opData.items.length == 0)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_11, [
                _createElementVNode("td", _hoisted_12, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Nessun elemento trovato",
                    text: "Nessun elemento trovato"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opData.items, (item, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.$filters.date(item.dataPagamento)), 1),
              _createElementVNode("td", _hoisted_13, _toDisplayString(item.importoEuro > 0 ? -item.importoEuro + ' €' : ''), 1),
              _createElementVNode("td", _hoisted_14, _toDisplayString(!(item.importoEuro > 0) ? -item.importoEuro + ' €' : ''), 1),
              _createElementVNode("td", null, _toDisplayString(item.numeroRicevuta), 1),
              _createElementVNode("td", null, _toDisplayString(item.nazione), 1),
              _createElementVNode("td", null, _toDisplayString(item.note), 1),
              _createElementVNode("td", null, [
                (!item.isBonus)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn btn-primary mr-2",
                      onClick: ($event: any) => (_ctx.downloadRicevuta(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Scarica ricevuta",
                        text: "Scarica ricevuta"
                      })
                    ], 8, _hoisted_15))
                  : _createCommentVNode("", true),
                (!item.isBonus && _ctx.$store.state.isAdmin())
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "btn btn-danger",
                      onClick: ($event: any) => (_ctx.deleteRicevuta(item))
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Elimina",
                        text: "Elimina"
                      })
                    ], 8, _hoisted_16))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["items"])
  ]))
}